import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export function ConfirmDialog(props: {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  variant?: 'default' | 'destructive';
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={props.open}
      onOpenChange={(next) => {
        if (!next && !props.loading) props.onCancel();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{props.title}</DialogTitle>
          <DialogDescription>{props.description}</DialogDescription>
        </DialogHeader>
        {props.children && <div className="py-2">{props.children}</div>}
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={props.onCancel} disabled={props.loading}>
            {t('common.cancel')}
          </Button>
          <Button
            type="button"
            variant={props.variant === 'destructive' ? 'destructive' : 'default'}
            onClick={props.onConfirm}
            disabled={props.loading}
          >
            {props.confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
